/* global G */
import { curry } from 'lib/util'

/**
 * Returns all keys in the root of `item` that have `meta` in their name as
 * its own object with the `meta` key stripped from the keys.
 *
 * @example
 * { metatype: 'foo', metastatus: 50, key: 'bar' } -> { type: 'foo', status: 50 }
 *
 * @param {Object} item an object containing data to extract from
 * @returns {Object}
 * @private
 */
const _metaProps = item => Object
  .keys(item)
  .filter(k => k.includes('meta'))
  .reduce((acc, key) => {
    const mk = key.split('meta')[1]
    acc[mk] = item[key]
    return acc
  }, {})

/**
 * Map Meta Event Handler
 *
 * Executes `fn`, which should be a search handler, receives the results
 * and maps `item.meta*` to `item.meta.*`
 *
 * @param {Function} fn                     search handler to execute
 * @param {Gaia.AppModule.Spec} module      app module
 * @param {Gaia.AppModule.Action} component action component
 * @param {PlatformEvent} event             the event that triggered this handler
 * @returns {Promise<Object|Array>}
 */
const mapMeta = async (fn, module, component, event) => {
  const result = await fn(module, component, event)

  const data = (result.data || result || []).map(item => ({
    ...item,
    meta: _metaProps(item),
  }))

  return result.data
    ? { ...result, data }
    : data
}

export default curry(mapMeta)
